import React from 'react'
import type { ITooltipParams } from '@ag-grid-community/core'
import { GRID_COL_TO_PARAM_FIELD, getOverrideValue } from './planAndRateFields'

function formatTooltipValue(v: unknown): string {
  if (v === true) return '✓ (true)'
  if (v === false) return '✗ (false)'
  if (v === null || v === undefined || v === '') return '-'
  return String(v)
}

const CONTAINER_STYLE: React.CSSProperties = {
  background: '#fff',
  border: '1px solid #e8e8e8',
  borderRadius: 8,
  padding: '10px 14px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
  minWidth: 160,
}

const ROW_STYLE: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 24,
  marginBottom: 4,
  fontSize: 13,
}

const LABEL_STYLE: React.CSSProperties = { color: '#8c8c8c' }
const VALUE_STYLE: React.CSSProperties = { fontWeight: 600, color: '#595959' }

export function CompareUpdateTooltip(params: ITooltipParams) {
  const { data, colDef, value } = params
  const field = colDef && 'field' in colDef ? colDef.field : undefined
  if (!field) return null

  if (value === '__override__') {
    const overrideParams = data?.__overrideParams as
      | Record<string, unknown>
      | null
      | undefined
    const paramField = GRID_COL_TO_PARAM_FIELD[field] ?? field
    const overrideVal = getOverrideValue(paramField, overrideParams ?? null)
    const ideonVal = data[field]
    const liveVal = (
      data._currentValue as Record<string, unknown> | undefined
    )?.[field]
    const hasLive = data._currentValue !== undefined
    const isDraft = data?.__overrideStatus === 'DRAFT'
    const badgeColor = isDraft ? '#1e40af' : '#15803d'
    const valueColor = isDraft ? '#1e3a8a' : '#166534'
    return (
      <div style={CONTAINER_STYLE}>
        <div
          style={{
            color: badgeColor,
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: '0.5px',
            marginBottom: 8,
          }}
        >
          {isDraft ? 'DRAFT OVERRIDE' : 'OVERRIDE APPLIED'}
        </div>
        <div style={ROW_STYLE}>
          <span style={{ ...LABEL_STYLE, color: valueColor, fontWeight: 700 }}>
            {isDraft ? 'Draft record' : 'Confirmed record'}
          </span>
          <span style={{ fontWeight: 700, color: valueColor }}>
            {formatTooltipValue(overrideVal)}
          </span>
        </div>
        <div style={ROW_STYLE}>
          <span style={LABEL_STYLE}>Ideon record</span>
          <span style={VALUE_STYLE}>{formatTooltipValue(ideonVal)}</span>
        </div>
        {hasLive && (
          <div style={{ ...ROW_STYLE, marginBottom: 0 }}>
            <span style={LABEL_STYLE}>Sureco record</span>
            <span style={VALUE_STYLE}>{formatTooltipValue(liveVal)}</span>
          </div>
        )}
      </div>
    )
  }

  const stagingVal = data[field]
  const liveVal = (data._currentValue as Record<string, unknown> | undefined)?.[
    field
  ]

  return (
    <div style={CONTAINER_STYLE}>
      <div
        style={{
          color: '#d97706',
          fontWeight: 700,
          fontSize: 11,
          letterSpacing: '0.5px',
          marginBottom: 8,
        }}
      >
        MODIFIED
      </div>
      <div style={ROW_STYLE}>
        <span style={{ ...LABEL_STYLE, color: '#92400e', fontWeight: 700 }}>
          Ideon record
        </span>
        <span style={{ fontWeight: 700, color: '#92400e' }}>
          {formatTooltipValue(stagingVal)}
        </span>
      </div>
      <div style={{ ...ROW_STYLE, marginBottom: 0 }}>
        <span style={LABEL_STYLE}>Sureco record</span>
        <span style={VALUE_STYLE}>{formatTooltipValue(liveVal)}</span>
      </div>
    </div>
  )
}
